import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { GetFieldDefinitionsResult } from './get-field-definitions.result';

/**
 * Get Field Definitions Use Case
 * Retrieves all field definitions with their constraint types
 */
@Injectable({ providedIn: 'root' })
export class GetFieldDefinitionsUseCase {
  private readonly _repository = inject(CaseFormRepository);

  public execute(): Observable<GetFieldDefinitionsResult> {
    return this._repository.getFieldDefinitions();
  }
}
